"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var refUtils = _interopRequireWildcard(require("../../../../../utils/refs"));
var eventsUtils = _interopRequireWildcard(require("../../../../../utils/events"));
var _SharedIdentity = _interopRequireDefault(require("../SharedIdentity"));
var _Role = _interopRequireDefault(require("../Role"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.293 4.293a1 1 0 0 1 1.414 0L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414L13.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 0 1 0-1.414z"
  }));
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.005 3a1 1 0 0 1 1 1v7.01H20a1 1 0 1 1 0 2h-6.995V20a1 1 0 1 1-2 0v-6.99H4a1 1 0 1 1 0-2h7.005V4a1 1 0 0 1 1-1z"
  }));
};
PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "user-row": "IdentityRow__user-row__3rPMa",
  "userRow": "IdentityRow__user-row__3rPMa",
  "role": "IdentityRow__role__24bUu",
  "actions": "IdentityRow__actions__1fvd4",
  "action": "IdentityRow__action__1Zby4",
  "action-icon": "IdentityRow__action-icon__189BN",
  "actionIcon": "IdentityRow__action-icon__189BN"
}; 
require('./IdentityRow.css');
var IdentityRow = /*#__PURE__*/function (_React$Component) {
  function IdentityRow() {
    var _this;
    (0, _classCallCheck2.default)(this, IdentityRow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IdentityRow, [].concat(args));
    (0, _defineProperty2.default)(_this, "undoIconRef", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)(_this, "removeIconRef", /*#__PURE__*/_react.default.createRef());
    return _this;
  }
  (0, _inherits2.default)(IdentityRow, _React$Component);
  return (0, _createClass2.default)(IdentityRow, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var identity = this.props.identity;
      if (!prevProps.identity.isMarkedAsDeleted && identity.isMarkedAsDeleted) {
        refUtils.focus(this.undoIconRef);
      }
      if (prevProps.identity.isMarkedAsDeleted && !identity.isMarkedAsDeleted) {
        refUtils.focus(this.removeIconRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isCurrentUser = _this$props.isCurrentUser,
        onRemoveIdentity = _this$props.onRemoveIdentity,
        onRoleChange = _this$props.onRoleChange,
        onUndoRemoveIdentity = _this$props.onUndoRemoveIdentity,
        identity = _this$props.identity;
      return /*#__PURE__*/_react.default.createElement("li", {
        className: styles.userRow,
        "data-test-id": "user-row"
      }, /*#__PURE__*/_react.default.createElement(_SharedIdentity.default, {
        identity: identity,
        isCurrentUser: isCurrentUser
      }), /*#__PURE__*/_react.default.createElement(_Role.default, {
        identity: identity,
        className: styles.role,
        isCurrentUser: isCurrentUser,
        onRoleChange: onRoleChange
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.actions
      }, !isCurrentUser && !identity.isMarkedAsDeleted ? /*#__PURE__*/_react.default.createElement("span", {
        role: "button",
        tabIndex: "0",
        "aria-label": "Remove user permission",
        "data-test-id": "share-asset-remove-icon",
        ref: this.removeIconRef,
        className: styles.action,
        onClick: function onClick() {
          return onRemoveIdentity(identity);
        },
        onKeyDown: eventsUtils.onEnterKey(function () {
          return onRemoveIdentity(identity);
        })
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: styles.actionIcon,
        size: 20
      }, /*#__PURE__*/_react.default.createElement(CloseIcon, null))) : null, !isCurrentUser && identity.isMarkedAsDeleted ? /*#__PURE__*/_react.default.createElement("span", {
        role: "button",
        tabIndex: "0",
        "aria-label": "Restore removed user permission",
        "data-test-id": "share-asset-undo-remove-icon",
        className: styles.action,
        ref: this.undoIconRef,
        onClick: function onClick() {
          return onUndoRemoveIdentity(identity);
        },
        onKeyDown: eventsUtils.onEnterKey(function () {
          return onUndoRemoveIdentity(identity);
        })
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: 20
      }, /*#__PURE__*/_react.default.createElement(PlusIcon, null))) : null));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(IdentityRow, "propTypes", {
  identity: _propTypes.default.object.isRequired,
  isCurrentUser: _propTypes.default.bool.isRequired,
  onRemoveIdentity: _propTypes.default.func.isRequired,
  onUndoRemoveIdentity: _propTypes.default.func.isRequired,
  onRoleChange: _propTypes.default.func.isRequired
});
var _default = exports.default = IdentityRow;
//# sourceMappingURL=IdentityRow.js.map